import { render, staticRenderFns } from "./SharePlatforms.vue?vue&type=template&id=39591e0c&scoped=true&"
import script from "./SharePlatforms.vue?vue&type=script&lang=js&"
export * from "./SharePlatforms.vue?vue&type=script&lang=js&"
import style0 from "./SharePlatforms.vue?vue&type=style&index=0&id=39591e0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39591e0c",
  null
  
)

export default component.exports